<div class="loading-container-wrapper" [class]="{ active: loading }">
	@if (!loading) {
		@if (!afterLoadComponent) {
			<ng-content></ng-content>
		}
		@if (afterLoadComponent) {
			<ng-container *ngTemplateOutlet="afterLoadComponent"></ng-container>
		}
	}

	<div class="component-spinner">
		<ea-icon name="working" class="working" [hasMargin]="false"></ea-icon>
	</div>
</div>
